import { DataFetchWrapper } from "@tfg/ui"

import { OrganizationSettingsPage } from "~/pages/Brand/OrganizationSettings/ProductPages/OrganizationSettingsPage.tsx"
import { useGetOrganizationSettingsQuery } from "~/pages/Brand/OrganizationSettings/ProductPages/hooks.ts"
import { useAuth } from "~/store/auth-context.tsx"

export const ProductPages = () => {
  const { user } = useAuth()
  const query = useGetOrganizationSettingsQuery(user?.organization?.id)

  return (
    <DataFetchWrapper query={query}>
      {({ data: organization }) => (
        <OrganizationSettingsPage organization={organization} />
      )}
    </DataFetchWrapper>
  )
}
